import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2"; // Recommended for attractive alerts

function Contact({ loading = false }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const { data } = await axios.post(`${baseurl}submitContact`, formData);
      
      if (data.success) {
        Swal.fire("Sent!", "Your message has been received.", "success");
        setFormData({ name: "", email: "", subject: "", message: "" });
        e.target.reset(); // Clear form
      }
    } catch (err) {
      console.error("Submission error:", err);
      Swal.fire("Error", "Failed to send message. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-page py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-subtitle text-muted">
            Have questions? We'd love to hear from you.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {/* Info Cards (Same as before) */}
          <div className="col-lg-4 col-md-12">
            <div className="contact-info-wrapper">
               <div className="info-card">
                <div className="info-icon">📍</div>
                <div className="info-text">
                  <h5>Our Location</h5>
                  <p>123 Commerce St, Suite 100, <br/>New York, NY 10001</p>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon">📞</div>
                <div className="info-text">
                  <h5>Phone Number</h5>
                  <p>+1 (555) 000-1234</p>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon">✉️</div>
                <div className="info-text">
                  <h5>Email Address</h5>
                  <p>support@yourstore.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="col-lg-7 col-md-12">
            <div className="contact-form-card shadow-sm">
              {loading ? (
                <Skeleton count={5} height={50} className="mb-3" borderRadius={8} />
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        className="form-control"
                        placeholder="John Doe"
                        required
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        className="form-control"
                        placeholder="john@example.com"
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      className="form-control"
                      placeholder="How can we help?"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      className="form-control"
                      rows="5"
                      placeholder="Write your message here..."
                      required
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <button 
                    type="submit" 
                    className="btn btn-submit w-100" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending..." : "Send Message"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Styles same as previous */}

       <style>{`
        .contact-page {
          background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
          min-height: 80vh;
        }

        .contact-title {
          font-weight: 800;
          font-size: 2.5rem;
          color: #2d3436;
        }

        .contact-subtitle {
          max-width: 600px;
          margin: 0 auto;
          font-size: 1.1rem;
        }

        /* Info Cards Styling */
        .contact-info-wrapper {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .info-card {
          display: flex;
          align-items: center;
          padding: 25px;
          background: #fff;
          border-radius: 16px;
          border: 1px solid #eee;
          transition: transform 0.3s ease;
        }

        .info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
        }

        .info-icon {
          font-size: 2rem;
          margin-right: 20px;
          background: #fff0f0;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
        }

        .info-text h5 {
          margin-bottom: 5px;
          font-weight: 700;
          color: #2d3436;
        }

        .info-text p {
          margin-bottom: 0;
          color: #636e72;
          font-size: 0.95rem;
        }

        /* Form Styling */
        .contact-form-card {
          background: #fff;
          padding: 40px;
          border-radius: 20px;
          border: 1px solid #eee;
        }

        .form-label {
          font-weight: 600;
          color: #2d3436;
          font-size: 0.9rem;
        }

        .form-control {
          border-radius: 10px;
          padding: 12px 15px;
          border: 1px solid #e0e0e0;
          background-color: #fcfcfc;
          transition: all 0.3s ease;
        }

        .form-control:focus {
          border-color: #ff4757;
          box-shadow: 0 0 0 4px rgba(255, 71, 87, 0.1);
          background-color: #fff;
        }

        .btn-submit {
          background-color: #ff4757;
          color: white;
          padding: 14px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 1rem;
          border: none;
          transition: all 0.3s ease;
        }

        .btn-submit:hover {
          background-color: #e84118;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(255, 71, 87, 0.3);
          color: white;
        }

        /* Mobile Adjustments */
        @media (max-width: 768px) {
          .contact-title {
            font-size: 2rem;
          }
          .contact-form-card {
            padding: 25px;
          }
          .info-card {
            padding: 20px;
          }
          .info-icon {
            width: 50px;
            height: 50px;
            font-size: 1.5rem;
          }
        }
      `}</style>


    </section>
  );
}

export default Contact;